
export function getComponentNameTitleOrPath(component: any): string {
  return component.name?.en
  || (typeof component.name === 'string' && component.name)
  || component.title?.en
  || (typeof component.title === 'string' && component.title)
  || (typeof component.path === 'string' && component.path)
  || '';
}

export function getComponentIdentifier(component: any): string {
  return getComponentNameTitleOrPath(component)
  || component.targetField
  || component.targetPrefix
  || '';
}
